import React, { useEffect, useState } from "react";
import { useAuthGlobal } from "../../../../../../../../contexts/auth-context/auth-context";
import { DocumentsResponseModel } from "../../../../../../../../domain/models/documents";
import { FilterModel } from "../../../../../../../../domain/models/enum";
import DocumentsListDeveloper from "../../../../../../../../presentation/pages/admin/companies/list/documents/list";
import { settings } from "../../../../../../../configs/settings";
import { makeRemoteDocument } from "../../../../../../usecases/documents/remote-documents-factory";

import { generateFilter } from "./utils";
import { DeveloperProps } from "../../../../../../../../domain/models/developer.model";
import { makeRemoteDeveloper } from "../../../../../../usecases/developer/remote-developer-factory";
import { makeRemoteDeveloperCompanies } from "../../../../../../usecases/developer-companies/remote-developer-companies-factory";

function MakeDocumentsDeveloper({ match }: any): JSX.Element {
  const { profile, user } = useAuthGlobal();

  const [list, setList] = useState<DocumentsResponseModel>();

  const [params, setParams] = useState<FilterModel>({});

  const [loading, setLoading] = useState<boolean>();

  const [reload, setReload] = useState<boolean>(false);

  const [developer, setDeveloper] = useState<DeveloperProps>();

  const loadData = async (): Promise<void> => {
    try {
      setLoading(true);

      const devData = await makeRemoteDeveloper().loadById(
        match?.params?.id
      );
      
      setDeveloper(devData);

      if (devData?.id && devData?.company?.id) {
        const developerCompanyData = await makeRemoteDeveloperCompanies()
          .getByCompany(devData.company.id, devData.id);

        const data = await makeRemoteDocument().load({
          size: settings.perPage,
          sort: "issuedOn,desc",
          page: params?.page,
          query: params?.query,
          filters: generateFilter({
            ...params?.filters,
            developerCompany: developerCompanyData?.id,
          }),
        });

        setList(data);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, profile, user, reload]);

  const handleReload = (): void => {
    setReload((prev) => !prev);
  };

  return (
    <DocumentsListDeveloper
      // params={params}
      developer={developer}
      list={list}
      setParams={setParams}
      loading={loading}
      handleReload={handleReload}
    />
  );
}

export default MakeDocumentsDeveloper;
